import { useEffect, useReducer, useState } from "react";
import { ApiError } from "../../../lib/http/errors";
import type { ConsoleApi } from "../api/consoleApi";
import { RoomConnection } from "../lib/connection";
import { roomDeps } from "../lib/deps";

/**
 * 칠판 세션 연결(SR-TCH-02 · SR-AUTH-04 · 계약 §1.1) — 제어 평면이 교사에게만 주는 board 조인 토큰(5분)으로 룸에 붙는다.
 * 렌더 전용: 입력·이모트를 보내지 않는다(me.machine 이 없으니 RoomConnection 이 리모컨을 보내지 않는다 · 서버도 버린다).
 * 끊기면 5초마다 새 토큰으로(20초 창) — 룸이 없어졌으면(404) 닫힘.
 * FS-12 칠판 뷰와 FS-07 배치 도구(바닥 평면에 기계 자리 · 지금 물건)가 쓴다.
 */
export function useBoardConnection(api: ConsoleApi | null): RoomConnection | null {
  const [conn, setConn] = useState<RoomConnection | null>(null);
  const [, rerender] = useReducer((x: number) => x + 1, 0);
  useEffect(() => {
    if (!api) return;
    const d = roomDeps();
    const c = new RoomConnection({
      ticket: async () => {
        try {
          return await api.board();
        } catch (e) {
          if (e instanceof ApiError && e.status === 404) return null;
          throw e;
        }
      },
      connect: d.connect,
      now: d.now,
      setTimeout: (cb, ms) => window.setTimeout(cb, ms),
      clearTimeout: (h) => window.clearTimeout(h as number),
    });
    const off = c.onChange(rerender);
    setConn(c);
    c.start();
    return () => {
      off();
      c.dispose();
    };
  }, [api]);
  return conn;
}
